import { useState } from 'react';
import { ReactComponent as EyeIcon } from 'assets/icon/eye.svg';
import { ReactComponent as EyeSlashIcon } from 'assets/icon/eye-slash.svg';

type InputType = 'text' | 'password';
interface IInputField {
  placeholder?: string;
  value: string;
  disabled?: boolean;
  onChange: (data: string) => void;
  error?: string;
  onBlur?: () => void;
  type?: InputType;
  height?: string;
}

const InputField: React.FC<IInputField> = ({
  value = '',
  onChange = (data: string) => {},
  placeholder = '',
  error = '',
  disabled = false,
  onBlur = () => {},
  type = 'text',
  height = 'h-12',
}) => {
  const [showPass, setShowPass] = useState<boolean>(false);
  return (
    <div className="flex-col items-center w-full relative ">
      <input
        type={type === 'password' && showPass ? 'text' : type}
        className={`flex items-center px-4 h-10 placeholder:text-sm ${`lg:${height}`} border-1.5 rounded-1 bg-white border-grey focus:border-active outline-none text-base text-black2  placeholder:text-grey2 disabled:bg-grey1 w-full ${
          error ? 'border-red-500' : ''
        } ${disabled ? 'opacity-50' : ''}`}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        onBlur={onBlur}
      />
      {type === 'password' &&
        (showPass ? (
          <EyeSlashIcon
            className="absolute right-4 top-[6px] cursor-pointer text-grey-2"
            height={24}
            width={24}
            onClick={() => setShowPass(!showPass)}
          />
        ) : (
          <EyeIcon
            className="absolute right-4 top-[6px] cursor-pointer text-grey-2"
            height={24}
            width={24}
            onClick={() => setShowPass(!showPass)}
          />
        ))}
      {error && <p className="font-regular text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default InputField;
